var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter",class:{
	'counter--big': _vm.big,
	'counter--small': _vm.small,
	'counter--mini': _vm.mini,
}},[_c('button',{staticClass:"counter__btn",class:{
		'counter__btn--big': _vm.big,
		'counter__btn--small': _vm.small,
		'counter__btn--mini': _vm.mini,
	},on:{"click":function($event){$event.stopPropagation();return _vm.changeValue(-1)}}},[_c('img',{staticClass:"counter__btn-minus",attrs:{"src":require("@/assets/img/minus.svg"),"alt":"Minus"}})]),(!_vm.hasInput)?_c('div',{staticClass:"counter__value",class:{
			'counter__value--big': _vm.big,
			'counter__value--small': _vm.small,
			'counter__value--mini': _vm.mini,
		}},[_vm._v(" "+_vm._s(_vm.counter)+" ")]):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.counter),expression:"counter"}],staticClass:"counter__value",class:{
			'counter__value--big': _vm.big,
			'counter__value--small': _vm.small,
			'counter__value--mini': _vm.mini,
		},attrs:{"type":"number","min":_vm.min,"max":_vm.max},domProps:{"value":(_vm.counter)},on:{"input":[function($event){if($event.target.composing)return;_vm.counter=$event.target.value},_vm.handleInput]}}),_c('button',{staticClass:"counter__btn",class:{
		'counter__btn--big': _vm.big,
		'counter__btn--small': _vm.small,
		'counter__btn--mini': _vm.mini,
	},on:{"click":function($event){$event.stopPropagation();return _vm.changeValue(1)}}},[(_vm.uiColor == 'green')?_c('img',{staticClass:"counter__btn-plus",attrs:{"src":require("@/assets/img/plus.svg"),"alt":"Plus"}}):_c('img',{staticClass:"counter__btn-plus",attrs:{"src":require("@/assets/img/plusBlue.svg"),"alt":"Plus"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }